import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/* Layout */
import Layout from "@/layout";

/* Views (static imports so webpack bundles them instead of creating
   dozens of per-route async chunks — see stage server load issue) */
import LoginIndex from "@/views/login/index";
import LoginAuthTwoFactor from "@/views/login/auth-two-factor";
import LoginAuthSms from "@/views/login/auth-sms";
import ErrorPage403 from "@/views/error-page/403";
import ErrorPage404 from "@/views/error-page/404";
import UserForgotPassword from "@/views/user/forgot-password";
import UserNewPassword from "@/views/user/new-password";
import DashboardIndex from "@/views/dashboard/index";
import CompanyInfo from "@/views/company/info";
import CompanyCreate from "@/views/company/create";
import CompanyEdit from "@/views/company/edit";
import CompanyIndex from "@/views/company/index";
import ProjectIndex from "@/views/project/index";
import ProjectInfo from "@/views/project/info";
import BankAccountIndex from "@/views/bank-account/index";
import BankAccountDetail from "@/views/bank-account/detail";
import CustomerIndex from "@/views/customer/index";
import CustomerInfoComponent from "@/views/customer/components/customer-info";
import CustomerEdit from "@/views/customer/edit";
import CustomerEditV2 from "@/views/customer/v2/edit";
import IntroducerIndex from "@/views/introducer/index";
import ReportIndex from "@/views/report/index";
import SearchIndex from "@/views/search/index";
import PricingTemplate from "@/views/pricing/pricing-template";
import UserIndex from "@/views/user/index";
import UserRestrict from "@/views/user/restrict";
import ProfileIndex from "@/views/profile/index";
import FirewallIndex from "@/views/firewall/index";
import FirewallTransactionDetail from "@/views/firewall/transaction/detail";
import FirewallBeneficiaryDetail from "@/views/firewall/beneficiary/detail";
import RulesIndex from "@/views/rules/index";
import BlacklistIndex from "@/views/blacklist/index";
import WebhookIndex from "@/views/webhook/index";
import GroupLinkIndex from "@/views/group-link/index";
import Ifxv2SubAccountIndex from "@/views/ifxv2-subaccount/index";

export const constantRoutes = [
  {
    path: "/login",
    component: LoginIndex,
    hidden: true
  },
  {
    path: "/login/two-factor-authentication/:uid",
    component: LoginAuthTwoFactor,
    hidden: true
  },
  {
    path: "/login/sms-authentication/:uid",
    component: LoginAuthSms,
    hidden: true
  },

  {
    path: "/403",
    component: ErrorPage403,
    hidden: true
  },
  {
    path: "/404",
    component: ErrorPage404,
    hidden: true
  },

  {
    path: "/lost-password",
    component: UserForgotPassword,
    hidden: true
  },

  {
    path: "/forgot/:token",
    component: UserNewPassword,
    hidden: true
  },

  {
    path: "/",
    component: Layout,
    redirect: "/dashboard",
    meta: {
      roles: ["superadmin", "admin", "user"]
    },
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        component: DashboardIndex,
        meta: {
          title: "Dashboard",
          icon: "dashboard",
          noCache: true,
          roles: ["superadmin", "admin", "user"]
        }
      },
      {
        path: "info/:uid",
        name: "CompanyInfo",
        component: CompanyInfo,
        meta: {
          title: "Company Info",
          icon: "company",
          noCache: true,
          activeMenu: "/company",
          roles: ["superadmin"]
        },
        hidden: true
      },
      {
        path: "create/:vender_type",
        name: "CompanyCreate",
        component: CompanyCreate,
        meta: {
          title: "Create Company",
          icon: "company",
          noCache: true,
          activeMenu: "/company",
          roles: ["superadmin"]
        },
        hidden: true
      },
      {
        path: "edit/:uid",
        name: "CompanyEdit",
        component: CompanyEdit,
        meta: {
          title: "Edit Company",
          icon: "company",
          noCache: true,
          activeMenu: "/company",
          roles: ["superadmin"]
        },
        hidden: true
      }
    ]
  },
  {
    path: "/company",
    component: Layout,
    meta: {
      roles: ["superadmin"]
    },
    children: [
      {
        path: "",
        name: "Company",
        component: CompanyIndex,
        meta: {
          title: "Company",
          icon: "company",
          noCache: true,
          activeMenu: "/company",
          roles: ["superadmin"]
        }
      },
      {
        path: "info/:uid",
        name: "RootCompanyInfo",
        component: CompanyInfo,
        meta: {
          title: "Company Info",
          icon: "company",
          noCache: true,
          activeMenu: "/company",
          roles: ["superadmin"]
        },
        hidden: true
      },
      {
        path: "create/:vender_type",
        name: "RootCompanyCreate",
        component: CompanyCreate,
        meta: {
          title: "Create Company",
          icon: "company",
          noCache: true,
          activeMenu: "/company",
          roles: ["superadmin"]
        },
        hidden: true
      },
      {
        path: "edit/:uid",
        name: "RootCompanyEdit",
        component: CompanyEdit,
        meta: {
          title: "Edit Company",
          icon: "company",
          noCache: true,
          activeMenu: "/company",
          roles: ["superadmin"]
        },
        hidden: true
      }
    ]
  },

  {
    path: "/project",
    component: Layout,
    meta: {
      roles: ["superadmin", "admin", "user"]
    },
    children: [
      {
        path: "",
        name: "Project",
        component: ProjectIndex,
        meta: {
          title: "Project",
          icon: "project",
          roles: ["superadmin", "admin", "user"]
        }
      },
      {
        path: ":project_uid",
        name: "ProjectCustomer",
        component: ProjectInfo,
        meta: {
          title: "Project Info",
          icon: "project",
          activeMenu: "/project",
          roles: ["superadmin", "admin", "user"]
        },
        hidden: true
      }
    ]
  },

  {
    path: "/bank-account",
    component: Layout,
    meta: {
      roles: ["superadmin", "admin"]
    },
    children: [
      {
        path: "",
        name: "BankAccount",
        component: BankAccountIndex,
        meta: {
          title: "Bank Account",
          icon: "bank-account",
          roles: ["superadmin", "admin"]
        }
      },
      {
        path: "view/:api_mode/:bankholder_id",
        name: "CustomerBankAccountDetail",
        component: BankAccountDetail,
        meta: {
          title: "Bank Account",
          icon: "bank-account",
          activeMenu: "/bank-account",
          roles: ["superadmin", "admin", "user"]
        },
        hidden: true
      }
    ]
  },

  {
    path: "/customer",
    component: Layout,
    meta: {
      roles: ["superadmin", "admin", "user"]
    },
    children: [
      {
        path: "",
        name: "Customer",
        component: CustomerIndex,
        meta: {
          title: "Customer",
          icon: "customer",
          roles: ["superadmin", "admin", "user"]
        }
      },
      {
        path: "view/:project_uid/:customer_uid",
        name: "CustomerBankAccount",
        component: CustomerInfoComponent,
        meta: {
          title: "Bank Account",
          icon: "bank-account",
          activeMenu: "/customer",
          roles: ["superadmin", "admin", "user"]
        },
        hidden: true
      },
      {
        path: "edit/:uid/:customer_type",
        name: "CustomerEdit",
        component: CustomerEdit,
        meta: {
          title: "Edit Customer",
          icon: "customer",
          noCache: true,
          activeMenu: "/customer",
          roles: ["superadmin", "admin", "user"]
        },
        hidden: true
      },
      {
        path: "v2/edit/:uid/:customer_type",
        name: "CustomerEditV2",
        component: CustomerEditV2,
        meta: {
          title: "Edit Customer",
          icon: "customer",
          noCache: true,
          activeMenu: "/customer",
          roles: ["superadmin", "admin", "user"]
        },
        hidden: true
      }
    ]
  },

  {
    path: "/introducer",
    component: Layout,
    meta: {
      roles: ["superadmin", "admin"]
    },
    children: [
      {
        path: "",
        name: "Introducer",
        component: IntroducerIndex,
        meta: {
          title: "Introducer",
          icon: "introducer",
          roles: ["superadmin", "admin"]
        }
      }
    ]
  },

  {
    path: "/report",
    component: Layout,
    meta: {
      roles: ["superadmin"]
    },
    children: [
      {
        path: "",
        name: "Report",
        component: ReportIndex,
        meta: {
          title: "Report",
          icon: "report",
          roles: ["superadmin"]
        }
      }
    ]
  },

  {
    path: "/search",
    component: Layout,
    meta: {
      roles: ["superadmin", "admin", "user"]
    },
    hidden: true,
    children: [
      {
        path: "",
        name: "Search",
        component: SearchIndex,
        meta: {
          title: "Report",
          icon: "report",
          roles: ["superadmin", "admin", "user"]
        }
      }
    ]
  },

  {
    path: "/pricing-template",
    component: Layout,
    meta: {
      roles: ["superadmin"]
    },
    children: [
      {
        path: "",
        name: "PricingTemplate",
        component: PricingTemplate,
        meta: {
          title: "Pricing Template",
          icon: "template",
          roles: ["superadmin"]
        }
      }
    ]
  },

  {
    path: "/user",
    component: Layout,
    meta: {
      roles: ["superadmin", "admin"]
    },
    children: [
      {
        path: "",
        name: "User",
        component: UserIndex,
        meta: {
          title: "User",
          icon: "user",
          roles: ["superadmin", "admin"]
        }
      }
    ]
  },

  {
    path: "/user-restrict",
    component: Layout,
    meta: {
      roles: ["superadmin"]
    },
    children: [
      {
        path: "",
        name: "Restrict",
        component: UserRestrict,
        meta: {
          title: "User restrict",
          icon: "restrict",
          roles: ["superadmin"]
        }
      }
    ]
  },

  {
    path: "/profile",
    meta: {
      roles: ["superadmin", "admin", "user"]
    },
    component: Layout,
    children: [
      {
        path: "",
        name: "Profile",
        component: ProfileIndex,
        meta: {
          title: "Profile",
          icon: "profile-setting",
          roles: ["superadmin", "admin", "user"]
        }
      }
    ]
  },
  {
    path: "/firewall",
    meta: {
      roles: ["superadmin", "admin", "user"],
      showBadge: true,
      badge: 0
    },
    hidden: true,
    component: Layout,
    children: [
      {
        path: "",
        name: "FirewallManage",
        component: FirewallIndex,
        meta: {
          title: "Firewall",
          icon: "firewall",
          roles: ["superadmin", "admin", "user"]
        }
      },

      {
        path: "transaction/detail/:transactionid",
        name: "FirewallTransactionDetail",
        component: FirewallTransactionDetail,
        meta: {
          title: "Firewall",
          icon: "firewall",
          roles: ["superadmin", "admin", "user"]
        },
        hidden: true
      },

      {
        path: "beneficiary/detail/:membercode/:beneficiaryid",
        name: "FirewallBeneficiaryDetail",
        component: FirewallBeneficiaryDetail,
        meta: {
          title: "Beneficiary",
          icon: "firewall",
          roles: ["superadmin", "admin", "user"]
        },
        hidden: true
      }
    ]
  },
  {
    path: "/rules",
    meta: {
      roles: ["superadmin", "admin", "user"]
    },
    component: Layout,
    hidden: true,
    children: [
      {
        path: "",
        name: "RulesManage",
        component: RulesIndex,
        meta: {
          title: "Rules",
          icon: "rule",
          roles: ["superadmin", "admin"]
        },
        hidden: true
      }
    ]
  },
  {
    path: "/blacklist",
    meta: {
      roles: ["superadmin", "admin", "user"]
    },
    component: Layout,
    hidden: true,
    children: [
      {
        path: "",
        name: "BlacklistManage",
        component: BlacklistIndex,
        meta: {
          title: "Blacklist",
          icon: "blacklist",
          roles: ["superadmin", "admin"]
        },
        hidden: true
      }
    ]
  },

  {
    path: "/webhooks",
    meta: {
      roles: ["superadmin", "admin"]
    },
    hidden: false,
    component: Layout,
    children: [
      {
        path: "",
        name: "WebhooksManage",
        component: WebhookIndex,
        meta: {
          title: "Webhooks",
          icon: "webhooks",
          roles: ["superadmin", "admin"]
        }
      }
    ]
  },

  {
    path: "/group-link",
    meta: {
      roles: ["superadmin", "admin"]
    },
    hidden: false,
    component: Layout,
    children: [
      {
        path: "",
        name: "MonthlyChargeGroupLink",
        component: GroupLinkIndex,
        meta: {
          title: "Group Link",
          icon: "network",
          roles: ["superadmin", "admin"]
        }
      }
    ]
  },

  {
    path: "/ifxv2-subaccounts",
    meta: {
      roles: ["superadmin"]
    },
    hidden: false,
    component: Layout,
    children: [
      {
        path: "",
        name: "Ifxv2SubAccounts",
        component: Ifxv2SubAccountIndex,
        meta: {
          title: "IFXv2 Sub-accounts",
          icon: "bank-account",
          roles: ["superadmin"]
        }
      }
    ]
  },

  {
    path: "*",
    redirect: "/404",
    hidden: true
  }
];

const createRouter = () =>
  new Router({
    mode: "history", // require service support
    scrollBehavior: () => ({
      y: 0
    }),
    routes: constantRoutes
  });

const router = createRouter();
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
